<template>
    <div>
        <!-- 左按钮 -->
        <button class="switch-btn left-btn" @click="prev" :disabled="mainProjectIndex === 0" v-if="mainProjects.length>1">
            ←
        </button>
        <!-- 右按钮 -->
        <button class="switch-btn right-btn" @click="next" :disabled="mainProjectIndex === mainProjects.length - 1" v-if="mainProjects.length>1">
            →
        </button>

        <!-- 中环 -->
        <div class="content" v-if="mainProjectIndex==0">
            <div class="title">
                <div class="icon"> </div>
                <h1>中环低碳(凤台)新能源光伏产业基地项目</h1>
            </div>
            <div class="img-container">
                <p class="p-left" style="margin-top: 5em;width:24em;">
                    中环低碳（凤台）新能源光伏产业基地项目位于安徽省凤台县中环低碳光伏产业园区内。为积极响应国家绿色节能政策对工业企业提出的能效提升要求，本项目对原有厂务自控系统实施了全面智能化升级。通过引入AI边缘计算服务器，成功构建AI智能优化控制系统，并针对制冷系统开展深入的算法调试与优化，实现了无人值守和显著节能的双重目标。</p>
                <img src="../../../../../assets/img/case/zhinengzhizao/zhinengzhizao_zhonghuan.png"></img>
            </div>
            <p>
                项目完成了“FMCS+AI”双核控制系统的自主研发，具备全自动群控与AI能效优化等五大智能功能。该系统成为光伏行业内首个通过ISO50001能源管理体系认证的制冷系统，实际节能率较合同约定值高出3.35个百分点。
            </p>
            <p>目前，该成果已在光储充一体化、氢能等多个清洁能源领域展现出良好的推广应用前景，为相关产业的智能化、绿色化发展提供了示范性解决方案。</p>
            <p style="text-align: center;"><img src="../../../../../assets/img/case/zhinengzhizao/zhinengzhizao_zhonghuan_1.png" style="width: 60%;margin:2em auto;"></img></p>
        </div>

        <!-- 西门子 -->
        <div class="content" v-if="mainProjectIndex==1">
            <div class="title">
                <div class="icon"> </div>
                <h1>西门子工业自动化产品中国智造基地项目</h1>
            </div>
            <br></br>
            <p>本项目内容包含SEWC IV期BMS系统，SEWCⅠ期制冷站、换热站控制系统改造项目，SEWCⅠ期中央空调制冷系统群控及智能优化控制项目几个部分。</p>
            <p>SEWC Ⅳ期包含新建的综合生产厂房，新建的生产配套用房(研发测试楼)，废品回收站，新建门卫，三期和四期间的两个空中连廊(tray)以及室外地下管网，道路，停车场和绿化工程等。</p>
            <p>
                BMS系统包含：厂区动力系统包括冷冻水系统、空压机系统、屋面风冷热泵系统、屋面工艺冷却水系统、生活水箱/消防水箱系统。
            </p>
            <p style="text-align: center;"><img src="../../../../../assets/img/case/zhinengzhizao/zhinengzhizao_ximenzi.png" style="width: 60%;margin:2em auto;"></img></p>
            <p>SEWCⅠ期制冷站、换热站控制系统改造项目包含：原有DDC系统升级为S7-1500，并完善现有控制系统</p>
            <p>SEWCⅠ期中央空调制冷系统群控及智能优化控制项目包含：为生产企业提供制冷系统的能效监控、分析和管理工具，采用节能增效算法提升制冷系统能效，最终达到降低能耗成本、提升运营效率、优化设备性能的目标。</p>
        </div>

        <!-- 度亘 -->
        <div class="content" v-if="mainProjectIndex==2">
            <div class="title">
                <div class="icon"> </div>
                <h1>南通某光电科技有限公司</h1>
            </div>
            <br></br>
            <p>本项目根据能源审计分析的结果对工厂核心能源消耗系统（制冷系统、供热系统、空调系统）实施主动AI智控节能管理。</p>
            <p>项目完成了制冷空调系统的闭环控制与冬季冷却塔免费供冷改造，加载AI智控优化算法，大幅提高冷源使用能效。经第三方机构对系统进行节能验证，制冷系统夏季工况能效（EER）由原来3.54提升至4.57以上，实现工厂动力系统节能降耗。</p>
            <p style="text-align: center;"><img src="../../../../../assets/img/case/zhinengzhizao/zhinengzhizao_dugeng.png" style="width: 60%;margin:2em auto;"></img></p>
            <p>
                目前制冷系统AI智控技术已经过多个项目验证，该成果在半导体厂房节能降耗与实现绿色工厂、零碳工厂的发展具有很好的应用前景。
            </p>
        </div>
                
        <foot-img-carousel type="zhinengzhizao" :projects="otherProjects" @change="showProjectDetail"></foot-img-carousel>
    </div>
</template>

<script>
import footImgCarousel from './footImgCarousel.vue';
export default {
    components: {
        footImgCarousel
    },
    data(){
        return {
            mainProjectIndex: 0,
            mainProjects: [{
                    cover: "zhonghuan",
                    title: "中环低碳(凤台)新能源光伏产业基地项目",
                    hasDetail: true
                },
                {
                    cover: "ximenzi",
                    title: "西门子工业自动化产品中国智造基地项目",
                    hasDetail: true
                },
                {
                    cover: "dugeng",
                    title: "南通某光电科技有限公司",
                    hasDetail: true
                }
            ],
            otherProjects:[]
        }
    },
  methods: {
      showProjectDetail(index) {
          this.mainProjectIndex = index
      },
      prev() {
          if (this.mainProjectIndex > 0) this.mainProjectIndex--;
      },
      next() {
          if (this.mainProjectIndex < this.mainProjects.length - 1) this.mainProjectIndex++;
      }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/case.less';
</style>